/* unplugin-vue-components disabled */import script from "./AI.vue?vue&type=script&setup=true&lang=js"
export * from "./AI.vue?vue&type=script&setup=true&lang=js"

import "./AI.vue?vue&type=style&index=0&id=6e991949&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e991949"]])

export default __exports__